module.exports = __webpack_public_path__ + "img/index-banner_product_2.73fd870.png";